/* eslint-disable import/no-anonymous-default-export */
export default [
    { id: 1, label: 'NYO', name: 'NYO', value: 'NYO' },
    { id: 2, label: 'SFO', name: 'SFO', value: 'SFO' },
    { id: 3, label: 'LAO', name: 'LAO', value: 'LAO' },
    { id: 4, label: 'DAO', name: 'DAO', value: 'DAO' },
    { id: 5, label: 'DCO', name: 'DCO', value: 'DCO' },
]
